import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/',
    name: 'home',
    meta: { middleware: authenticate },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/pages/Dashboard')
  }
]
